import { useLayoutEffect } from 'react';

import { TABLE_WATERMARK_ENABLED } from 'constants/tableWatermark';
import {
  registerWatermarkContainer,
  unregisterWatermarkContainer,
  updateWatermarkContainerConfig,
} from 'utils/tableWatermarkGuard';

export const useTableWatermarkGuard = (ref, config = null) => {
  const offsetTop = config && config.offsetTop;
  const left = config && config.left;
  const leftMobile = config && config.leftMobile;

  // Mount once — avoid observer churn on left/offset prop updates.
  useLayoutEffect(() => {
    if (!TABLE_WATERMARK_ENABLED) {
      return undefined;
    }

    const node = ref.current;

    if (!node) {
      return undefined;
    }

    registerWatermarkContainer(node, {
      offsetTop,
      left,
      leftMobile,
    });

    return () => unregisterWatermarkContainer(node);
  }, [ref]);

  useLayoutEffect(() => {
    if (!TABLE_WATERMARK_ENABLED) {
      return;
    }

    const node = ref.current;

    if (!node) {
      return;
    }

    updateWatermarkContainerConfig(node, {
      offsetTop,
      left,
      leftMobile,
    });
  }, [ref, offsetTop, left, leftMobile]);
};
